import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import { DrivingLicenceOptionsTypes } from '../components/Questions/DrivingLicenceQuestion/DrivingLicenseOptions'
import BaseValidator from './BaseValidator'

const DrivingLicenceValidator = (): BaseValidator => {
  const schema = yup.object().shape({
    drivingLicence: yup.string()
      .oneOf(DrivingLicenceOptionsTypes.map((o) => o.value))
      .required()
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      drivingLicence: state.drivingLicence
    })
  }
}

export default DrivingLicenceValidator
